import PackageList from './PackageList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Selectors
import { getApptMenuType } from 'store/reducers/appointment/selectors';
import { getServicePoint } from 'store/reducers/packages/selectors';
import { getActivePromotion } from 'store/reducers/promotions/selectors';
import {
  getIsQuoteAppt,
  getReadOnlyPackage
} from 'store/reducers/quoteAppt/selectors';

// Actions
import { setApptServicePoint } from 'store/reducers/appointment/actions';
import { updateReadOnlyPackage } from 'store/reducers/packages/actions';

const mapStateToProps = state => ({
  apptMenuType: getApptMenuType(state),
  servicePoint: getServicePoint(state),
  activePromotion: getActivePromotion(state),
  isQuoteAppt: getIsQuoteAppt(state),
  readOnlyPackage: getReadOnlyPackage(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setApptServicePoint, updateReadOnlyPackage }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PackageList);



// WEBPACK FOOTER //
// ./src/components/atoms/PackageList/PackageListContainer.js